import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { FiLoader, FiLogOut } from 'react-icons/fi';
import { FcGoogle } from 'react-icons/fc';
import { authService } from '../services/authService';

const AuthButton = ({ user, onAuthChange }) => {
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    try {
      setLoading(true);
      const user = await authService.signInWithGoogle();
      onAuthChange(user);
      toast.success('Successfully signed in!');
    } catch (error) {
      toast.error(error.message || 'Failed to sign in');
    } finally {
      setLoading(false);
    }
  };

  const handleSignOut = async () => {
    try {
      setLoading(true);
      await authService.signOut();
      onAuthChange(null);
      toast.success('Successfully signed out!');
    } catch (error) {
      toast.error(error.message || 'Failed to sign out');
    } finally {
      setLoading(false);
    }
  };

  if (user) {
    return (
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          {user.photoURL && (
            <img
              src={user.photoURL}
              alt={user.displayName || 'User'}
              className="w-8 h-8 rounded-full"
            />
          )}
          <div className="hidden sm:block">
            <p className="text-sm font-medium text-gray-900">
              {user.displayName || 'User'}
            </p>
            <p className="text-xs text-gray-500">{user.email}</p>
          </div>
        </div>
        <button
          onClick={handleSignOut}
          disabled={loading}
          className="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50"
          title="Sign out"
        >
          {loading ? (
            <FiLoader className="h-5 w-5 animate-spin" />
          ) : (
            <FiLogOut className="h-5 w-5" />
          )}
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={handleSignIn}
      disabled={loading}
      className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {loading ? (
        <FiLoader className="h-5 w-5 animate-spin text-blue-600" />
      ) : (
        <FcGoogle className="h-5 w-5" />
      )}
      <span className="text-sm font-medium text-gray-700">
        {loading ? 'Signing in...' : 'Sign in with Google'}
      </span>
    </button>
  );
};

export default AuthButton; 